import React, { useContext, useEffect, useState } from 'react';
import './ProductDisplay.css';
import star_icon from '../Assets/star_icon.png';
import star_dull_icon from '../Assets/star_dull_icon.png';
import { ShopContext } from '../../Context/ShopContext';
import ImageSlider from '../ImageSlider/ImageSlider';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'; // Importing icons from react-icons

const useResponsiveStyles = () => {
  const [containerStyles, setContainerStyles] = useState({
    width: '240px',
    height: '340px',
    margin: '0 auto',
  });

  useEffect(() => {
    const updateStyles = () => {
      if (window.innerWidth <= 480) {
        setContainerStyles({
          width: '300px', 
          height: '300px', 
          margin: '0 0',
        });
      } else if (window.innerWidth <= 560) {
        setContainerStyles({
          width: '250px', 
          height: '250px', 
          margin: '0 0',
        });
      } else if (window.innerWidth <= 768) {
        setContainerStyles({
          width: '300px', 
          height: '300px', 
          margin: '0 0',
        });
      } else if (window.innerWidth <= 900) {
        setContainerStyles({
          width: '320px', 
          height: '320px', 
          margin: '0 0',
        });
      } else if (window.innerWidth <= 1024) {
        setContainerStyles({
          width: '340px', 
          height: '340px', 
          margin: '0 0',
        });
      } else if (window.innerWidth <= 1330) {
        setContainerStyles({
          width: '340px', 
          height: '340px', 
          margin: '0 0',
        });
      } else {
        setContainerStyles({
          width: '340px', 
          height: '340px',
          margin: '0 auto',
        });
      }
    };

    window.addEventListener('resize', updateStyles);
    updateStyles();

    return () => window.removeEventListener('resize', updateStyles);
  }, []);

  return containerStyles;
};

const ProductDisplay = (props) => {
  const { product } = props;
  const { addToCart } = useContext(ShopContext);
  const [alertMessage, setAlertMessage] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecrement = () => {
    setQuantity((prevQuantity) => (prevQuantity > 1 ? prevQuantity - 1 : 1));
  };

  const handleAction = () => {
    if (product.available) {
      addToCart(product.id, quantity);
      setAlertMessage('Added to cart');
    } else {
      alert('This Product is not available');
    }
  };

  const handleInput = (e) => {
    const value = parseInt(e.target.value >= 0, 10);
    setQuantity(isNaN(value) ? 1 : value); // Set to 0 if the value is not a number
  };

  const slides = product.image;
  const containerStyles = useResponsiveStyles();

  return (
    <div className='mt-10 flex flex-col md:flex-row items-center justify-center px-[3%] md:px-[5%] lg:px-[10%] gap-5'>
      <div className="w-full md:w-2/5 flex items-center justify-center">
        <div style={containerStyles}>
          <ImageSlider slides={slides} />
        </div>
      </div>

      <div className="w-full md:w-3/5 rounded-xl p-6 mt-10 md:mt-0">
        <h1 className="text-2xl lg:text-4xl font-montserrat font-medium">{product.name}</h1>
        <div className="flex items-center mt-2">
          {(product.rating >= 1) ? <img src={star_icon} alt='star-icon' className='w-4 h-4 mr-1' /> : <img src={star_dull_icon} alt='star-icon' className='w-4 h-4 mr-1' />}
          {(product.rating >= 2) ? <img src={star_icon} alt='star-icon' className='w-4 h-4 mr-1' /> : <img src={star_dull_icon} alt='star-icon' className='w-4 h-4 mr-1' />}
          {(product.rating >= 3) ? <img src={star_icon} alt='star-icon' className='w-4 h-4 mr-1' /> : <img src={star_dull_icon} alt='star-icon' className='w-4 h-4 mr-1' />}
          {(product.rating >= 4) ? <img src={star_icon} alt='star-icon' className='w-4 h-4 mr-1' /> : <img src={star_dull_icon} alt='star-icon' className='w-4 h-4 mr-1' />}
          {(product.rating >= 5) ? <img src={star_icon} alt='star-icon' className='w-4 h-4 mr-1' /> : <img src={star_dull_icon} alt='star-icon' className='w-4 h-4 mr-1' />}
          <p className="ml-1 text-sm">( {product.no_of_rators} )</p>
        </div>
        <div className="mt-6 flex gap-4 items-center">
          <div className="text-xl font-semibold text-[#551E19]">Rs.{product.new_price}</div>
          {product.old_price ? <div className="text-base line-through">Rs.{product.old_price}</div> : <></>}
        </div>
        {product.description.formatted_text && <div className="text-base mt-5">
          {isExpanded || product.description.formatted_text.length <= 200 ? (
            product.description.formatted_text
          ) : (
            <>
              {product.description.formatted_text.substring(0, 200)}...
              <button className=" text-[#551E19]" onClick={() => setIsExpanded(true)}>See More</button>
            </>
          )}
          {isExpanded && (
            <button className=" text-[#551E19]" onClick={() => setIsExpanded(false)}>See Less</button>
          )}
        </div>}
        <div className='flex gap-8 sm:gap-10 mt-10 items-center'>
          <div className='mt-4 flex'>
            <div className="flex items-center justify-center border rounded-lg">
              <button 
                onClick={handleDecrement} 
                className="flex items-center justify-center bg-gray-200 text-gray-600 rounded-l-lg p-2 hover:bg-gray-300">
                <AiOutlineMinus />
              </button>
              <input 
                type="text" 
                value={quantity}
                className="w-12 text-center p-1 border-0 outline-none" 
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (Number(inputValue) >= 1 || inputValue === '') {
                    handleInput(e); // Call the handler only for valid values
                  }
                }}
              />
              <button 
                onClick={handleIncrement} 
                className="flex items-center justify-center bg-gray-200 text-gray-600 rounded-r-lg p-2 hover:bg-gray-300">
                <AiOutlinePlus />
              </button>
            </div>
          </div>
          <div className="mt-4">
            <button onClick={handleAction} className={`py-1 px-3 sm:px-12 text-sm sm:text-base rounded-lg text-white ${product.available ? 'bg-[#551E19] hover:bg-red-950' : 'bg-gray-300 cursor-not-allowed'}`}>
              {product.available ? 'ADD TO Cart' : 'UNAVAILABLE'}
            </button>
            {alertMessage && <p className="alert-message text-green-500 mt-2">{alertMessage}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDisplay;
